import React from "react";

const AnnotationMenuLabelIcon = () => {
  return (
    <React.Fragment>
      <span className="icon-square-label-1">
        <span className="path1"></span>
        <span className="path2"></span>
        <span className="path3"></span>
        <span className="path4"></span>
        <span className="path5"></span>
        <span className="path6"></span>
        <span className="path7"></span>
      </span>
    </React.Fragment>
  );
};

export default AnnotationMenuLabelIcon;
